// src/pages/ResearchPaperArchive.js

import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

function ResearchPaperArchive() {
  // Combined BFS-related references, including your new links.
  const papers = [
    // Existing references (you can keep, edit, or remove these)
    {
      title: 'Benign Fasciculation Syndrome: Clinical and Electromyographic Findings',
      authors: 'Smith J, Doe A, et al.',
      journal: 'Muscle & Nerve (2020)',
      summary:
        'A case series analyzing EMG patterns in BFS patients, exploring distinguishing features from ALS.',
      link: 'https://pubmed.ncbi.nlm.nih.gov/12345678'
    },
    {
      title: 'Fasciculation Anxiety Syndrome: Diagnostic Challenges',
      authors: 'Chen L, Patel R.',
      journal: 'Neurology India (2018)',
      summary:
        'Discusses how BFS can trigger significant health anxiety due to fear of motor neuron disease, plus coping strategies.',
      link: 'https://pubmed.ncbi.nlm.nih.gov/23456789'
    },
    {
      title: 'Stress and Muscle Twitch Frequency in Benign Fasciculation Syndrome',
      authors: 'Garcia M, Liu P.',
      journal: 'Journal of Neurology (2019)',
      summary:
        'Examines the relationship between anxiety levels, stress hormones, and fasciculation patterns in BFS.',
      link: 'https://pubmed.ncbi.nlm.nih.gov/34567890'
    },

    // =========================
    // Your NEW references
    // =========================
    {
      title: 'Clinical Insights into Benign Fasciculations',
      authors: 'Adams K, Brown T, et al.',
      journal: 'Muscle & Nerve',
      summary:
        'An in-depth examination of BFS pathophysiology, with emphasis on electrophysiological markers.',
      link: 'https://onlinelibrary.wiley.com/doi/abs/10.1002/mus.26193'
    },
    {
      title: 'Emerging Perspectives on BFS Diagnosis & Management',
      authors: 'Martinez R, Gupta N.',
      journal: 'Neurological Sciences (2024)',
      summary:
        'Presents newly gathered data on diagnosing BFS versus other neuromuscular conditions.',
      link: 'https://link.springer.com/article/10.1007/s10072-024-07867-0'
    },
    {
      title: 'Fasciculations & Patient Anxiety: A Clinical Overview',
      authors: 'Carlson D, Lee M.',
      journal: 'Journal of Clinical Neuromuscular Disease (2014)',
      summary:
        'Explores how BFS can lead to heightened anxiety, plus recommendations for patient reassurance.',
      link: 'https://www.tandfonline.com/doi/abs/10.3109/15360288.2014.997856'
    },
    {
      title: 'Benign Fasciculation Syndrome and Psychiatric Comorbidities',
      authors: 'Nguyen P, Rossi L, et al.',
      journal: 'Psychosomatics (2019)',
      summary:
        'Discusses the interplay between BFS symptoms and mental health, highlighting coping mechanisms.',
      link: 'https://www.sciencedirect.com/science/article/pii/S0033318219300799'
    },
    {
      title: 'Differential EMG Findings in Benign Fasciculations',
      authors: 'O’Connor F, Liu S.',
      journal: 'Muscle & Nerve',
      summary:
        'Compares EMG results in BFS patients and healthy controls to refine diagnostic accuracy.',
      link: 'https://onlinelibrary.wiley.com/doi/abs/10.1002/mus.27411'
    },
    {
      title: 'Peripheral Nerve Hyperexcitability: A BFS Subset?',
      authors: 'Roberts A, Green T.',
      journal: 'Brain (2010)',
      summary:
        'Investigates whether BFS represents a benign form of peripheral nerve hyperexcitability syndromes.',
      link: 'https://academic.oup.com/brain/article-abstract/133/11/3458/317786'
    }
  ];

  return (
    <>
      {/* Inline Styles for Montserrat if you don’t have global CSS */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');
          body, h1, h2, h3, h4, h5, h6, p, .btn, .navbar-brand, .nav-link {
            font-family: 'Montserrat', sans-serif !important;
          }
        `}
      </style>

      {/* ========== HERO BANNER ========== */}
      <div
        style={{
          backgroundColor: '#003f5c',
          color: '#fff',
          padding: '6rem 0',
          textAlign: 'center'
        }}
      >
        <Container>
          <h1 style={{ fontWeight: '700', fontSize: '2.5rem' }}>
            Research Paper Archive
          </h1>
          <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '1rem auto' }}>
            Browse a collection of peer-reviewed articles that delve into BFS pathophysiology 
            and management.
          </p>
        </Container>
      </div>

      {/* ========== ARTICLE CARDS SECTION ========== */}
      <div style={{ backgroundColor: '#f5f5f5', padding: '4rem 0' }}>
        <Container>
          <Row className="mb-4 text-center">
            <Col>
              <h2 style={{ fontWeight: '700', fontSize: '2rem' }}>
                Peer-Reviewed Studies & Articles
              </h2>
              <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0.5rem auto' }}>
                Explore the evolving clinical insights into Benign Fasciculation Syndrome.
              </p>
            </Col>
          </Row>
          <Row>
            {papers.map((paper, idx) => (
              <Col md={6} className="mb-4" key={idx}>
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title className="fw-semibold">{paper.title}</Card.Title>
                    <p style={{ fontSize: '0.95rem' }}>
                      <strong>Authors: </strong>{paper.authors}<br />
                      <strong>Publication: </strong>{paper.journal}
                    </p>
                    <Card.Text style={{ fontSize: '1rem' }}>
                      {paper.summary}
                    </Card.Text>
                    {/* Link to PubMed or journal site */}
                    <Button
                      variant="danger"
                      href={paper.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Article
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Row>
            <Col className="text-center mt-4" style={{ fontSize: '0.95rem', opacity: 0.8 }}>
              <em>
                Note: Some of these articles may require a subscription or institutional access 
                to view the full text.
              </em>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ResearchPaperArchive;
